var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

// Fix navigation loading issue on article pages
// Ghost's dropdown() function waits for logo image to load before adding .is-dropdown-loaded
// This causes navigation items to be hidden (opacity: 0) until logo loads
// We ensure navigation is visible immediately by adding .is-dropdown-loaded right away
(function() {
    'use strict';
    function ensureNavVisible() {
        const headMenu = document.querySelector('.gh-head-menu');
        const nav = headMenu?.querySelector('.nav');
        if (nav && nav.children.length > 0) {
            // Add .is-dropdown-loaded immediately so navigation items are visible
            // This prevents the issue where nav items are hidden until logo loads
            if (!document.body.classList.contains('is-dropdown-loaded')) {
                document.body.classList.add('is-dropdown-loaded');
            }
        }
    }
    
    // Run immediately if DOM is already loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ensureNavVisible);
    } else {
        ensureNavVisible();
    }
    
    // Also run after DOMContentLoaded fires (in case it hasn't fired yet)
    document.addEventListener('DOMContentLoaded', ensureNavVisible);
})();

featured();
darkPage();
footerGroup();

// Call the function when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupFootnotes();
        randomizeCardRotation();
        introHighlight();
    });
} else {
    setupFootnotes();
    randomizeCardRotation();
    introHighlight();
}

window.addEventListener('scroll', introHighlight);

pagination();

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function randomizeCardRotation() {
    'use strict';
    // Get all category card media elements
    const cardMediaElements = document.querySelectorAll('.category-card-media');
    
    // If no elements found, exit early
    if (!cardMediaElements.length) return;
    
    // For each element, set a random rotation
    cardMediaElements.forEach(element => {
        // Generate random number between -20 and 20, but avoid -4 to 4 range
        let randomRotation;
        do {
            randomRotation = Math.floor(Math.random() * 41) - 20; // 41 possible values from -20 to 20
        } while (randomRotation >= -4 && randomRotation <= 4);
        
        // Set the custom property on the element
        element.style.setProperty('--random-rotation', `${randomRotation}deg`);
        
        // Set a longer initial transition duration (will be overridden by CSS after animation completes)
        element.style.transition = 'transform 0.6s cubic-bezier(0.18, 0.89, 0.32, 1.28)';
        
        // Reset to CSS-defined transition after initial animation
        setTimeout(() => {
            element.style.transition = '';
        }, 800); // Match the duration above
    });
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 1,
        loop: false,
        nav: false,
        mouseDrag: true,
        responsive: {
            0: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function darkPage() {
    var isDark = body.classList.contains('tag-hash-dark') ? 'dark' : 'light';
    html.classList.add(`${isDark}-page`);
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-nav");
    if (!footerNav) return;

    const items = document.querySelectorAll(".footer-nav .nav li");
    
    if (!footerNav || !items.length) return;
    
    const groups = [];
    let index = null;

    // Process all items first
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else if (index !== null) {
            const link = item.querySelector('a');
            if (link) {
                groups[index].items.push({ text, link: link.href });
            }
        }
    });

    // Only proceed if we found groups
    if (groups.length === 0) return;

    // Create the new structure
    groups.forEach((group) => {
        const div = document.createElement('div');
        div.classList.add("footer-nav-group");
        const h6 = document.createElement('h6');
        h6.classList.add("footer-group-header", "section-title");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
            ul.append(li);
        });
        div.append(h6, ul);
        footerNav.appendChild(div);
    });

    // Remove the old nav if we have new content
    if (groups.length > 0) {
        const oldNav = document.querySelector(".footer-nav ul.nav");
        if (oldNav && oldNav.parentNode) {  // Check if element exists and has a parent
            oldNav.remove();
        }
    }
}

function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}


function introHighlight() {
    const textIntro = document.querySelector('.hero-intro.tag-hash-intro-animate');
    if (!textIntro) return;

    // Select paragraphs and headings (h1, h2, h3, h4, h5, h6)
    const paragraphs = textIntro.querySelectorAll('p');
    const headings = textIntro.querySelectorAll('h1, h2, h3, h4, h5');
    
    // Use querySelectorAll for all target elements directly
    const elements = textIntro.querySelectorAll('p, h1, h2, h3, h4, h5');
    const viewportHeight = window.innerHeight;

    // Function to split text into sentences and sentence fragments (by periods, question marks, exclamation marks, and commas)
    function splitIntoSentences(text) {
        // First split by periods, question marks, and exclamation marks
        const mainSentences = text.match(/[^\.!\?]+[\.!\?]+/g) || [text];
        
        // Then further split each sentence by commas
        const fragments = [];
        mainSentences.forEach(sentence => {
            // Check if the sentence has any commas
            if (sentence.includes(',')) {
                // Split by comma and preserve the comma at the end of each fragment
                const commaFragments = sentence.split(',').map((fragment, index, array) => {
                    // For all but the last fragment, add the comma back
                    return index < array.length - 1 ? fragment + ',' : fragment;
                });
                fragments.push(...commaFragments);
            } else {
                // If no commas, keep the sentence as is
                fragments.push(sentence);
            }
        });
        
        // Return the combined fragments, filtering out any empty ones
        return fragments.filter(fragment => fragment.trim().length > 0);
    }

    // Process each element only once
    if (!textIntro.dataset.processed) {
        elements.forEach(element => {
            // Skip empty elements or those without text content
            if (!element.innerText.trim()) return;
            
            const sentences = splitIntoSentences(element.innerText);
            element.innerHTML = ''; // Clear the element content

            sentences.forEach(sentence => {
                const span = document.createElement('span');
                span.className = 'sentence';
                // Add additional class to identify if it's from a heading
                if (element.tagName.toLowerCase().match(/^h[1-6]$/)) {
                    span.classList.add('heading-sentence');
                }
                span.innerText = sentence.trim() + ' ';
                element.appendChild(span);
            });
        });
        
        // When first processed, only highlight the first sentence
        const firstSentence = textIntro.querySelector('.sentence');
        if (firstSentence) {
            firstSentence.classList.add('intro-highlight');
        }
        
        textIntro.dataset.processed = 'true';
    }

    const allSentences = textIntro.querySelectorAll('.sentence');
    
    // Use fixed values instead of calculating based on viewport height
    const middleOfViewport = 400; // Fixed value in pixels
    
    // Use a fixed value for the trigger point
    const triggerPoint = 320;

    let lastHighlightedIndex = -1;

    // Check if the intro has entered the fixed trigger point
    const introRect = textIntro.getBoundingClientRect();
    const introHasEntered = introRect.top < triggerPoint;

    // Apply highlighting without blurring
    allSentences.forEach((sentence, index) => {
        const rect = sentence.getBoundingClientRect();
        if (introHasEntered && rect.top < middleOfViewport) {
            sentence.classList.add('intro-highlight');
            lastHighlightedIndex = index;
        } else {
            // Don't remove highlight from first sentence on initial load
            if (index !== 0 || window.scrollY > 10) {
                sentence.classList.remove('intro-highlight');
            }
        }
    });

    // Check if we've scrolled past the text intro
    if (introRect.bottom < 0) {
        // If we've scrolled past, highlight all sentences
        allSentences.forEach(sentence => {
            sentence.classList.add('intro-highlight');
        });
    }
}